import ApiInstance from "./ApiInstance";

export interface SelfTestSummary {
  slug: string;
  title: string;
  intro: string;
  topic?: string;
  // "open" = vrij invulbaar; "assignable" = reflectie-vragenlijst, vragen
  // alleen na toewijzing door je psycholoog (API-afgedwongen).
  visibility?: "open" | "assignable";
  questionCount: number;
}
export interface SelfTestDetail {
  slug: string;
  title: string;
  intro: string;
  scaleLabels: string[];
  questions: { text: string }[];
  source?: string; // instrument attribution
}

// Questionnaires are informative only: there is no scoring API — answers stay
// in the browser and are shown back verbatim (MDR/MDCG 2019-11 decision).
class SelfTestApi {
  async list(): Promise<SelfTestSummary[]> {
    const { data } = await ApiInstance.getApi().get("/selftests");
    return data.selftests;
  }
  async get(slug: string): Promise<SelfTestDetail> {
    const { data } = await ApiInstance.getApi().get(`/selftests/${slug}`);
    return data;
  }
}

const selfTestApi = new SelfTestApi();
export default selfTestApi;
